interface ComparisonFeature {
    name: string;
    mobileName?: string;
    donationForm: boolean;
    fundraisingPage: boolean;
    event: boolean;
}

const features: ComparisonFeature[] = [
    {
        name: 'Accepts donations',
        donationForm: true,
        fundraisingPage: true,
        event: true,
    },
    {
        name: 'Goal bar',
        donationForm: true,
        fundraisingPage: true,
        event: true,
    },
    {
        name: 'Embed on a website',
        donationForm: true,
        fundraisingPage: true,
        event: true,
    },
    {
        name: 'Custom branding',
        donationForm: true,
        fundraisingPage: true,
        event: true,
    },
    {
        name: 'Mobile app',
        donationForm: true,
        fundraisingPage: true,
        event: true,
    },
    {
        name: 'Peer-to-peer fundraising',
        mobileName: 'Peer-to-peer',
        donationForm: false,
        fundraisingPage: true,
        event: true,
    },
    {
        name: 'Matching donations',
        donationForm: false,
        fundraisingPage: true,
        event: true,
    },
    {
        name: 'Supporter feed',
        donationForm: false,
        fundraisingPage: true,
        event: true,
    },
    {
        name: 'Auction',
        donationForm: false,
        fundraisingPage: true,
        event: true,
    },
    {
        name: 'Sell & manage tickets',
        mobileName: 'Sell tickets',
        donationForm: false,
        fundraisingPage: false,
        event: true,
    },
];

const FORM_VIDEO_DESKTOP = 'https://givebuttercdn.com/videos/form-campaign-preview.mp4';
const PAGE_VIDEO_DESKTOP = 'https://givebuttercdn.com/videos/page-campaign-preview.mp4';
const EVENT_VIDEO_DESKTOP = 'https://givebuttercdn.com/videos/event-campaign-preview.mp4';
const FORM_VIDEO_MOBILE = 'https://givebuttercdn.com/videos/form-mobile-preview.mp4';
const PAGE_VIDEO_MOBILE = 'https://givebuttercdn.com/videos/page-mobile-preview.mp4';
const EVENT_VIDEO_MOBILE = 'https://givebuttercdn.com/videos/event-mobile-preview.mp4';

export {
    features,
    FORM_VIDEO_DESKTOP,
    PAGE_VIDEO_DESKTOP,
    EVENT_VIDEO_DESKTOP,
    FORM_VIDEO_MOBILE,
    PAGE_VIDEO_MOBILE,
    EVENT_VIDEO_MOBILE,
};
export type { ComparisonFeature };
